import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'antd';
import HelpForm from 'components/Contact/HelpForm';
import styles from './Contact.module.scss';

const Contact = (): ReactElement => {
  const { t } = useTranslation();

  return (
    <div className={`${styles.page} contactPage`}>
      <h1 className={styles.title}>{t('pages.contact.title')}</h1>
      <Row justify="center">
        <Col xs={22} sm={20} md={16} lg={14}>
          <HelpForm className={styles.formCard} />
        </Col>
      </Row>
    </div>
  );
};

export default Contact;
